// Mount Vue App first to avoid conflicts
$(document).ready(function () {
    fixEmptyLinks();
});


/**
 * Avoid scrolling up when clicking on links to #
 */
function fixEmptyLinks() {
    $('body').on('click', 'a[href="#"]', function (evt) {
        evt.preventDefault();
    });
}